<script>
import SidebarMenuStuffToEatCollapsed from './sidebar-menu-stuff-to-eat-collapsed';

export default {
  name: 'sidebar-menu-stuff-to-eat-meal-collapsed',
  mixins: [SidebarMenuStuffToEatCollapsed],
  data() {
    return {
      startingUrl: '/professional/stuff-to-eat/food-products/',
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ui/menu/stuff-to-eat/sidebar-menu-stuff-to-eat-food-product-collapsed.vue